import { render, staticRenderFns } from "./PublishFormCard.vue?vue&type=template&id=5e510172&scoped=true"
import script from "./PublishFormCard.vue?vue&type=script&lang=js"
export * from "./PublishFormCard.vue?vue&type=script&lang=js"
import style0 from "./PublishFormCard.vue?vue&type=style&index=0&id=5e510172&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e510172",
  null
  
)

export default component.exports